module.exports = __webpack_public_path__ + "static/media/platform-ebook.c7edac55.png";